/** @jsx jsx */
import { node, string } from 'prop-types'
import { Card, Text, Flex, jsx, Divider, Image, Link } from 'theme-ui'

const ManageWebsiteFeatureCard = ({
  title,
  icon,
  description,
  subSectionButtonLink,
  ...props
}) => {
  return (
    <Link
      target="_blank"
      href={`${process.env.GATSBY_COMMLINK_URL}${subSectionButtonLink}`}
      style={{ textDecoration: 'none', color: 'black' }}
    >
      <Card
        variant="feature"
        data-automation-id={`${title
          .toLowerCase()
          .replaceAll(' ', '-')}-feature-card`}
        sx={{
          minWidth: 268,
          mr: 0,
          height: '100%',
          transition: 'box-shadow 0.2s, border-color 0.2s',
          borderRight: '1px solid #979491',
          borderBottom: '1px solid #979491',
          background: '#FAFAFA',
          boxShadow: '0 2px 35px 0 rgba(28, 34, 38, 0.15)',
          '&:hover': {
            boxShadow: '3px 3px 10px 0 #6F6C69',
            borderBottom: '1px solid #6F6C69',
            borderRight: '1px solid #6F6C69',
          },
        }}
        {...props}
      >
        <Flex sx={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
          <Flex sx={{ mt: '2px', width: 24, height: 24, flexShrink: 0 }}>
            <Image
              variant="cardIcon"
              src={icon}
              data-automation-id={`${title
                .toLowerCase()
                .replaceAll(' ', '-')}-feature-icon`}
              sx={{ width: '100%', height: '100%' }}
            />
          </Flex>
          <Text
            data-automation-id={`${title
              .toLowerCase()
              .replaceAll(' ', '-')}-title`}
            variant="h6"
            sx={{
              ml: 3,
              lineHeight: '22.5px',
              fontWeight: '450',
              fontFamily: 'Haptik',
              fontStyle: 'normal',
              display: 'flex',
              fontSize: '20px',
              alignItems: 'flex-start',
              color: 'var(--Primary-Black, #000)',
            }}
          >
            {title}
          </Text>
        </Flex>
        <Divider sx={{ width: '100%', my: 4, color: '#979491' }} />
        <Text variant="xSmallText">{description}</Text>
      </Card>
    </Link>
  )
}

ManageWebsiteFeatureCard.propTypes = {
  icon: node.isRequired,
  description: string.isRequired,
  title: string.isRequired,
  subSectionButtonLink: string,
}

export default ManageWebsiteFeatureCard
